import React from 'react'
import { useIntl } from 'react-intl'
import { Select } from './index'

const activeDeletedOptions = [
	{ value: 'all', label: 'All' },
	{ value: 'active', label: 'Active' },
	{ value: 'deleted', label: 'Deleted' },
]
const ActiveDeletedSelect = ({ onChange, value, ...rest }) => {
	const { formatMessage } = useIntl()
	return (
		<Select
			{...rest}
			label={formatMessage({ id: 'global.active_deleted' })}
			menuItems={activeDeletedOptions}
			selectProps={{
				onChange,
				value,
			}}
		/>
	)
}

export default ActiveDeletedSelect
